const HitsPerPageConfiguration = [
    { label: "24", value: 24, default: true },
    { label: "36", value: 36 },
    {
        label: "96",
        value: 96
    }
];

const DefaultHitsPerPage = HitsPerPageConfiguration.find(
    (hitsPerPage) => hitsPerPage.default
)?.value!;

export { DefaultHitsPerPage, HitsPerPageConfiguration };
